import { netsparkAxios } from 'core/services/HTTPService';
import { IOrderDataWithRelatedOrders } from 'core/models/order.models';
import getContractManagementItemUrl from './apiUrls';

export const getContractManagementItemById = (id: string | number) => (
  netsparkAxios.get<IOrderDataWithRelatedOrders>(getContractManagementItemUrl(id))
);

export default getContractManagementItemById;
